import axios from "axios";

const pageNews = document.getElementById("page-nyheter");
const button = document.getElementById("button-load-more-news");

function hideButton() {
  if (document.querySelector('.page-news-list').dataset.page >= document.querySelector('.page-news-list').dataset.max) {
    button.style.display = 'none';
  } else {
    return;
  }
}


function ajaxLoadMore() {
  if (button) {
    button.addEventListener("click", (event) => {
      let currentPage = document.querySelector(".page-news-list").dataset.page;
      let maxPages = document.querySelector(".page-news-list").dataset.max;

      let params = new URLSearchParams();
      params.append("action", "load_more_posts");
      params.append("current_page", currentPage);
      params.append("max_pages", maxPages);
      
      axios.post("/dragster_2022/wp-admin/admin-ajax.php", params).then((res) => {
        // console.log({ res });

        let postsList = document.querySelector('.page-news-list');
        postsList.innerHTML += res.data.data;

        document.querySelector('.page-news-list').dataset.page++;

        hideButton();
      });
    });
  }
}

if (pageNews) {
  ajaxLoadMore();
  hideButton();
}
